import update from 'immutability-helper';
import SelfServeBuilderSidePanelConstants, { SelfServeBuilderSidePanelTypes } from './SelfServeBuilderSidePanelConstants';

const initialState = {
  [SelfServeBuilderSidePanelTypes.POST_BUILDER]: {
    isOpen: false,
  },
  [SelfServeBuilderSidePanelTypes.TOOLBOX]: {
    isOpen: false,
  },
};

const SelfServeBuilderSidePanelHandler = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case SelfServeBuilderSidePanelConstants.SET_IS_OPEN:
      return update(state, {
        [action.panelType]: {
          isOpen: { $set: action.isOpen },
        },
      });
    default:
      return state;
  }
};

export default SelfServeBuilderSidePanelHandler;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderSidePanel/SelfServeBuilderSidePanelReducer.jsx